export default __webpack_public_path__ + "static/media/coin.9a28e48a.svg";